import { BaseApi } from './base.api.js';

export class ProcessApi extends BaseApi {
    constructor(client) {
        super(client, '/process');
    }
}
